import React from 'react';

import { getBreadcrumbs } from '@autovia-uk/polaris-components/sharedPartials/getBreadcrumbs';
import { getIndexPageItems } from '@autovia-uk/polaris-components/sharedPartials/getIndexPageItems';
import { getLoadMore } from '@autovia-uk/polaris-components/sharedPartials/getLoadMore';
import { getTaxonomyFilter } from '@autovia-uk/polaris-components/sharedPartials/getTaxonomyFilter';
import { getSponsorInfo } from '@autovia-uk/polaris-components/sharedPartials/getSponsorInfo';
import { useViewportType } from '@autovia-uk/polaris-components/components/protons/ViewportChecker';

import { indexPropsShape } from './props-shape';
import 'Styles/components/templates/_Index.scss';

const IndexTemplate = ({
  layoutData: {
    page: {
      url,
      title,
      breadcrumbs,
      filters,
      showFilters,
      sponsor,
    },
  },
  pagination: {
    hasMore,
    isLoading,
    loadMore,
    nextUrl,
    pages,
    setPageRef,
  },
  config: {
    newsletterConfig,
    adBreakPoints,
    breakpoints,
  },
}) => {
  const config = {
    newsletterConfig: {
      ...newsletterConfig,
      ...{
        mainTitle: '',
        position: 'inline',
        extraClassNames: {
          '-index': true,
        },
      },
    },
    adBreakPoints,
  };
  const extraClassNames = { '-index': true, 'polaris__core-content': true };

  const { isMobile } = useViewportType({
    breakpointsMobile: breakpoints.mobile,
    breakpointsDesktop: breakpoints.desktop,
  });

  const loadMoreParams = {
    label: isLoading ? 'Loading...' : 'Load More',
    loadMore,
    isLoading,
    extraClassNames: {
      'polaris__load-more--small': true,
    },
    href: nextUrl,
  };

  const taxonomyFilters = Array.isArray(filters) ? filters.map(f => ({
    label: f.title,
    value: f.url,
  })) : null;
  if (taxonomyFilters && taxonomyFilters.length) {
    taxonomyFilters.unshift({
      label: 'ALL',
      value: url,
    });
  }
  const taxonomyFilterParams = {
    label: 'Show me:',
    listModeOptions: {
      seeMoreLabel: 'See more',
      seeLessLabel: 'See less',
      icon: 'down-chevron',
    },
    currentPageUrl: url,
    content: taxonomyFilters,
  };

  const taxonomyFiltersMarkup = (
    <div className="polaris__gray--bg polaris__core-content polaris__content">
      {getTaxonomyFilter(taxonomyFilterParams)}
    </div>
  );

  return (
    <>
      <div className="polaris__body">
        <main className="polaris__main" id="main">
          <div className="polaris__core-content polaris__content">
            <div className="polaris__index--headings-container">
              {getBreadcrumbs({ breadcrumbs, title, extraClassNames: { '-with-title': true } })}
              {getSponsorInfo({ sponsor })}
            </div>
          </div>

          {showFilters && taxonomyFilters !== null && taxonomyFilters.length > 0 && taxonomyFiltersMarkup}

          <div className="polaris__content">
            <div data-previous="1" ref={setPageRef} />
            {getIndexPageItems({
              articlesPerRow: 4,
              config,
              extraClassNames,
              includePromoBox: true,
              nativeAdPosition: 7,
              newsletterPosition: 7,
              pages,
              promoboxPosition: false,
              setPageRef,
              templateType: 'indexTemplate',
              articleCardProps: {
                datePosition: 'bottom',
                showRating: true,
              },
              isMobile,
            })}

          </div>

          <div className="polaris__core-content polaris__content">
            {hasMore && getLoadMore(loadMoreParams)}
          </div>
        </main>
      </div>
    </>
  );
};

IndexTemplate.propTypes = {
  ...indexPropsShape,
};

export { IndexTemplate };
